import React, { useState } from 'react';
import { Button, Space, Tooltip } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { CargoItemInputFields } from 'components/common/cargo-item-input-fields';
import type { ICargoItemInputFieldsSectionProps } from 'components/common/cargo-item-input-fields-section/types';

export const CargoItemInputFieldsSection: React.FC<ICargoItemInputFieldsSectionProps> = (props) => {
  const { form, initialItemCount = 1, name, withoutStack = false } = props;
  const [itemCount, setItemCount] = useState(() => Math.max(initialItemCount, 1));

  const decreaseItemCount = () => setItemCount((count) => (count > 1 ? count - 1 : 1));
  const increaseItemCount = () => setItemCount((count) => count + 1);

  return (
    <>
      {Array(itemCount)
        .fill('')
        .map((_, index) => (
          <CargoItemInputFields key={index} form={form} name={name} index={index} withoutStack={withoutStack} />
        ))}

      <Space.Compact block>
        <Tooltip title='Add item'>
          <Button icon={<PlusOutlined />} size={'small'} onClick={increaseItemCount} />
        </Tooltip>
        <Tooltip title='Delete last item'>
          <Button icon={<MinusOutlined />} size={'small'} onClick={decreaseItemCount} />
        </Tooltip>
      </Space.Compact>
    </>
  );
};
